import Select from "./Select";

function PreferredTitleSelect({title, initialError, id, value, setValue, required, updateObject}) {
    const options = [
        {value: "Monsieur", title: "Monsieur"},
        {value: "Madame", title: "Madame"},
        {value: "Madame et Monsieur", title: "Madame et Monsieur"},
        {value: "Madame, Monsieur", title: "Madame, Monsieur"},
        {value: "Messieurs", title: "Messieurs"},
        {value: "Mesdames", title: "Mesdames"},
        {value: "Maître", title: "Maître"},
        {value: "Docteur", title: "Docteur"},
        {value: "Autre", title: "Autre"}
    ];

    return (
        <Select title={title} initialError={initialError} id={id} value={value}
                setValue={setValue} required={required} updateObject={updateObject} options={options} />
    );
}

export default PreferredTitleSelect;